import * as React from "react";
import "./help.css";
import VideoModal from "../../components/video-modal/video-modal";
import ImageModal from "../../components/image-modal/image-modal";
import fffVideo1 from "../../assets/images/fff-video-1.png";
import fffVideo2 from "../../assets/images/fff-video-2.png";
import { List, ListItem } from "semantic-ui-react";

export default function Help(): JSX.Element {
    return (
        <div className="instructionsDocuments">
            <h1>Hilfe</h1>
            <List relaxed="very">
                <ListItem>
                    <p>Videos zum Einstieg</p>
                    <div className="mediaList">
                        <VideoModal thumbnailUrl={fffVideo1}
                                    videoUrl="https://intranet.lu.ch/collaboration/rawi/sites/fff/Dokumente/400%20FFF-Informationssystem/1%20Erste%20Schritte.mp4"
                                    caption="Erste Schritte"/>
                        <VideoModal thumbnailUrl={fffVideo2}
                                    videoUrl="https://intranet.lu.ch/collaboration/rawi/sites/fff/Dokumente/400%20FFF-Informationssystem/2%20Projekt%20anlegen.mp4"
                                    caption="Projekt anlegen"/>
                    </div>
                </ListItem>
                <ListItem>
                    Anleitung FFF-Informationssystem
                    (<a
                    href="https://intranet.lu.ch/collaboration/rawi/sites/fff/Dokumente/400%20FFF-Informationssystem/Anleitung_FFF_Informationssystem.pdf?d=w0b447fbff2994cb385718604ee52dfc0"
                    rel="noreferrer"
                    target="_blank">PDF</a>)
                </ListItem>
                <ListItem>
                    Zuständigkeiten Nachführung Attribute nach Dienststellen / Abteilungen
                    (<a
                    href="https://intranet.lu.ch/collaboration/rawi/sites/fff/Dokumente/400%20FFF-Informationssystem/FFF_Informationssystem_Zustaendigkeiten.pdf?d=w3a52d259f6d04e1288c0591a976e1224"
                    rel="noreferrer"
                    target="_blank">PDF</a>)
                </ListItem>
                <ListItem>
                    FFF-Richtlinie
                    (<a href="https://fruchtfolgeflaechen.lu.ch/Richtlinie_Fruchtfolgeflaechen"
                        rel="noreferrer"
                        target="_blank">Webseite</a> / <a
                    href="https://intranet.lu.ch/collaboration/buwdds/sites/FFF/Freigegebene%20Dokumente/FFF-Richtlinie_Version-2.0_1.-September-2025_22631.pdf?d=w3e3b45b70148477fa12926ae7735382f"
                    rel="noreferrer"
                    target="_blank">PDF</a>)
                </ListItem>
                <ListItem>
                    Internes Vollzugsdokument
                    (<a
                    href="https://intranet.lu.ch/collaboration/buwdds/sites/FFF/Freigegebene%20Dokumente/internes-FFF-Vollzugsdokument_Version-3.0_1.-Septe_78831.pdf?d=wb34f651f7e0d411695e875df607668d2"
                    target="_blank"
                    rel="noreferrer">PDF</a>)
                </ListItem>
                <ListItem>
                    <p>Prozessabläufe</p>
                    <div className="mediaList">
                        <ImageModal
                            thumbnailUrl="https://intranet.lu.ch/collaboration/rawi/sites/fff/Dokumente/400%20FFF-Informationssystem/Prozessablauf_Beanspruchung_Nutzungsplanaenderung.png"
                            imageUrl="https://intranet.lu.ch/collaboration/rawi/sites/fff/Dokumente/400%20FFF-Informationssystem/Prozessablauf_Beanspruchung_Nutzungsplanaenderung.png"
                            caption="Beanspruchung: Nutzungsplanänderung"/>
                        <ImageModal
                            thumbnailUrl="https://intranet.lu.ch/collaboration/rawi/sites/fff/Dokumente/400%20FFF-Informationssystem/Prozessablauf_Beanspruchung_Baubewilligung.png"
                            imageUrl="https://intranet.lu.ch/collaboration/rawi/sites/fff/Dokumente/400%20FFF-Informationssystem/Prozessablauf_Beanspruchung_Baubewilligung.png"
                            caption="Beanspruchung: Baubewilligung"/>
                        <ImageModal
                            thumbnailUrl="https://intranet.lu.ch/collaboration/rawi/sites/fff/Dokumente/400%20FFF-Informationssystem/Prozessablauf_Neuschaffung_Auszonung.png"
                            imageUrl="https://intranet.lu.ch/collaboration/rawi/sites/fff/Dokumente/400%20FFF-Informationssystem/Prozessablauf_Neuschaffung_Auszonung.png"
                            caption="Neuschaffung: Auszonung"/>
                        <ImageModal
                            thumbnailUrl="https://intranet.lu.ch/collaboration/rawi/sites/fff/Dokumente/400%20FFF-Informationssystem/Prozessablauf_Neuschaffung_Bodenverbesserung.png"
                            imageUrl="https://intranet.lu.ch/collaboration/rawi/sites/fff/Dokumente/400%20FFF-Informationssystem/Prozessablauf_Neuschaffung_Bodenverbesserung.png"
                            caption="Neuschaffung: Bodenverbesserung"/>
                    </div>
                </ListItem>
            </List>
        </div>
    );
}
